import { UntitledIcon } from '@faceup/icons'
import { ulArrowLeft } from '@faceup/icons/ulArrowLeft'

export const ArrowGoBack = () => <UntitledIcon icon={ulArrowLeft} className='text-black text-2xl' />
